import { WEBHOOK } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Webhook = (payload) => {
  return apiInstance.post(WEBHOOK, payload);
};
